module.exports = __webpack_public_path__ + "static/media/ciro_client_light.94890b95.png";